import { hasClass } from '@opten/dom/has-class';
import { Component } from '@opten/compiler/metadata/component';

declare var TweenMax: any;
declare var TweenLite: any;

class DotPicture {
	x: number;
	y: number;
	top: number;
	left: number;
	width: number;
	height: number;
	scale: number;
	fill: string;

	constructor(color: string) {
		this.x = 0;
		this.y = 0;

		this.left = 0;
		this.top = 0;

		this.width = 4;
		this.height = 4;
		this.fill = color;//"#a6c032";// "#D2DF98";

		this.scale = 1;
	}

	draw(context: CanvasRenderingContext2D) {
		context.setTransform(this.scale, 0, 0, this.scale,
			this.left + this.x, this.top + this.y);

		// context.moveTo(0, -this.height / 2);
		// context.lineTo(0, this.height / 2);

		// context.moveTo(-this.width / 2, 0);
		// context.lineTo(this.width / 2, 0);
		//context.fillRect(this.x, this.y, this.width, this.height);
		context.beginPath();

		context.arc(this.x, this.y, 2, 0, Math.PI * 2, true);
		context.fillStyle = this.fill;

		context.fill();
	}
}

@Component({ className: 'js-dots-picture' })
export class DotsPictureComponent {
	signs = [];
	mouse = { x: 0, y: 0 };
	gridXLength = 80;
	gridYLength = 40;
	invisibleBorder = 40;
	space = 20;

	mouseMoved = false;
	mouseOver = false;
	context: CanvasRenderingContext2D;
	canvasWidth: number;
	canvasHeight: number;
	canvasColor: string;
	resizeId: NodeJS.Timeout;


	constructor(private element: HTMLCanvasElement) {
		this.context = this.element.getContext('2d');
		this.canvasColor = '#a6c032';

		this.init();
	}

	handleResize() {
		this.context.clearRect(0, 0, this.element.width, this.element.height);
		this.init();
	}

	init() {
		if (hasClass(this.element, 'c-dots-picture--footer')) {
			this.canvasColor = '#698bb5';
			this.element.width = document.body.clientWidth;
			this.invisibleBorder = 5;

			window.addEventListener('resize', () => {
				clearTimeout(this.resizeId);
				this.resizeId = setTimeout(() => this.handleResize(), 300);
			});
			//window.addEventListener('resize', () => this.handleResize());
		}
		this.canvasWidth = this.element.width;
		this.canvasHeight = this.element.height;
		this.gridXLength = this.canvasWidth / this.space;
		this.gridYLength = this.canvasHeight / this.space;

		for (var i = 0; i < this.gridXLength; i++) {
			this.signs[i] = [];

			for (var j = 0; j < this.gridYLength; j++) {
				var sign = new DotPicture(this.canvasColor);

				sign.left = ((this.canvasWidth - this.invisibleBorder) / (this.gridXLength + 1) * (i + 1)) + (this.invisibleBorder / 2);
				sign.top = ((this.canvasHeight - this.invisibleBorder) / (this.gridYLength + 1) * (j + 1)) + (this.invisibleBorder / 2);

				sign.width = this.space;
				sign.height = this.space;

				this.signs[i][j] = sign;
			}
		}

		TweenLite.ticker.addEventListener('tick', () => this.draw());

		this.element.addEventListener('mousemove', (e) => this.handleMouseMove(e));
		this.element.addEventListener('touchmove', (e) => this.handleTouchMove(e));

		this.element.addEventListener('touchstart', () => {
			this.mouseOver = true;
		});
		this.element.addEventListener('mouseenter', () => {
			this.mouseOver = true;
		});

		this.element.addEventListener('mouseleave', () => this.handleMouseLeave())
		this.element.addEventListener('touchend', () => this.handleMouseLeave())

	}


	draw() {
		if (this.mouseOver && this.mouseMoved) {
			this.calculateIconPosition();
			this.mouseMoved = false;
		}

		this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
		this.context.save();
		this.context.beginPath();
		for (var i = 0; i < this.gridXLength; i++) {
			for (var j = 0; j < this.gridYLength; j++) {
				var sign = this.signs[i][j];

				sign.draw(this.context);
			}
		}
		this.context.closePath();
		this.context.restore();
	}

	calculateIconPosition() {
		const spaceFromPositionAffected = 3;
		for (var i = 0; i < this.gridXLength; i++) {
			for (var j = 0; j < this.gridYLength; j++) {
				var sign = this.signs[i][j];
				var radius = 100;
				var dx = this.mouse.x - sign.left - (sign.width * spaceFromPositionAffected);
				var dy = this.mouse.y - sign.top - (sign.height * spaceFromPositionAffected);
				var dist = Math.sqrt(dx * dx + dy * dy) || 1;

				var angle = Math.atan2(dy, dx);

				if (dist < radius) {
					const scaleFactor = 3 - ((dist / radius) * 2);

					radius = dist;
					TweenMax.to(sign, 0.3, { scale: scaleFactor });
				} else {
					TweenMax.to(sign, 0.3, { scale: 1 });
				}

				// TweenMax.to(sign, 0.3, {
				// 	x: (Math.cos(angle) * radius) * -1,
				// 	y: (Math.sin(angle) * radius) * -1
				// });
				TweenMax.to(sign, 0.3, {
					x: (Math.cos(angle) * 5) * -1,
					y: (Math.sin(angle) * 5) * -1
				});
			}
		}
	}


	handleMouseMove(e: MouseEvent) {
		var rect = this.element.getBoundingClientRect();
		this.mouse.x = e.clientX - rect.left;
		this.mouse.y = e.clientY - rect.top;

		this.mouseMoved = true;
	}

	handleTouchMove(e: TouchEvent) {
		var rect = this.element.getBoundingClientRect();
		this.mouse.x = e.touches[0].clientX - rect.left;
		this.mouse.y = e.touches[0].clientY - rect.top;

		this.mouseMoved = true;
	}

	handleMouseLeave() {
		this.mouseOver = false;
		for (var i = 0; i < this.gridXLength; i++) {
			for (var j = 0; j < this.gridYLength; j++) {
				var sign = this.signs[i][j];
				TweenMax.to(sign, 0.3, { x: 0, y: 0, scale: 1 });
			}
		}
	}
}